export const organizationOverviewTypePatcher = (response) => {
    return {
        ...response,
        __typename: 'OrganizationOverview',
    };
};
